import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { concatMap, filter, map, switchMap } from 'rxjs/operators';

import { APIResponseInterface } from 'src/app/modelli/inwit/api-response.interface';

import { GestioneLoginService } from '../login/gestione-login.service';
import { UtilsService } from '../utils.service';
import { AnalysisLegendInterface } from 'src/app/modelli/inwit/analisi/analysis-legend.interface';
import { AnalysisUtilsService } from 'src/app/mappa/right-sidebar/analysis-utils.service';


@Injectable({
  providedIn: "root",
})
export class AnalysisLegendService {
  public analysisLegend$: BehaviorSubject<AnalysisLegendInterface[]> = new BehaviorSubject<AnalysisLegendInterface[]>(null);
  public analysisLegendUpdateRequest$: Subject<boolean> = new Subject<boolean>();

  private analysisLegendGetUrl = this.gestioneLoginService.creaURL("analysis-legend", "get");
  private analysisLegendUpdateUrl = this.gestioneLoginService.creaURL("analysis-legend", "put");
  private analysisLegendAddUrl = this.gestioneLoginService.creaURL("analysis-legend", "post");
  private analysisLegendRemoveUrl = this.gestioneLoginService.creaURL("analysis-legend", "delete");
  private analysesLegendGetListUrl = this.gestioneLoginService.creaURL("analysis-legend", "getList");

  constructor(
    private gestioneLoginService: GestioneLoginService,
    private utilsService: UtilsService
  ) { }


  addAnalysisLegend(legend: AnalysisLegendInterface) {
    return this.utilsService.postRequest(this.analysisLegendAddUrl, legend).pipe(map((res) => {
      this.analysisLegendUpdateRequest$.next(true);
      return res;
    })) as Observable<APIResponseInterface<{}>>;
  }

  getAnalysisLegend(id: string): Observable<APIResponseInterface<AnalysisLegendInterface[]>> {
    return this.utilsService.getRequest(this.analysisLegendGetUrl, { id }) as Observable<
      APIResponseInterface<AnalysisLegendInterface[]>>
  }

  getAnalysesLegend(): Observable<APIResponseInterface<AnalysisLegendInterface[]>> {
    return this.utilsService.getRequest(this.analysesLegendGetListUrl, {}) as Observable<APIResponseInterface<AnalysisLegendInterface[]>>
  }

  updateAnalysisLegend(analysis: AnalysisLegendInterface): Observable<APIResponseInterface<AnalysisLegendInterface[]>> {
    return this.utilsService.putRequest(this.analysisLegendUpdateUrl, analysis).pipe(map((res) => {
      this.analysisLegendUpdateRequest$.next(true);
      return res;
    })) as Observable<APIResponseInterface<AnalysisLegendInterface[]>>;
  }

  removeAnalysisLegend(id: number): Observable<APIResponseInterface<{}>> {
    return this.utilsService.deleteRequest(`${this.analysisLegendRemoveUrl}?id=${id}`, null).pipe(map((res) => {
      this.analysisLegendUpdateRequest$.next(true);
      return res;
    })) as Observable<
      APIResponseInterface<{}>>;

  }
}
